import { capitalCase } from 'change-case';

export function formatSchemaName(name: string): string {
  if (!name) return '';
  return capitalCase(name);
}
